// 'react-dom' should only be used within this package. All other packages should import through this package
// eslint-disable-next-line no-restricted-imports
import type { Renderer } from 'react-dom';
// eslint-disable-next-line no-restricted-imports
import { render as ReactDOMRender } from 'react-dom';
import * as React from 'react';
import { isFeatureEnabled } from 'owa-feature-flags';
import { FluentContext } from './FluentContext';

export const render = function render(
    ...[element, container, callback]: Parameters<typeof ReactDOMRender>
): ReturnType<typeof ReactDOMRender> {
    const wrappedElement = isFeatureEnabled('fwk-fluent-v9') ? (
        <FluentContext>{element}</FluentContext>
    ) : (
        element
    );
    return ReactDOMRender(
        <React.StrictMode>{wrappedElement}</React.StrictMode>,
        container,
        callback
    );
} as Renderer;
